import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Download, CheckCircle2 } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="w-full py-24 px-4 bg-[#161616] border-t border-gray-800 text-center overflow-hidden" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-43">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative order-2 lg:order-1" data-id="element-44">
            <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full opacity-20 transform translate-y-4" data-id="element-45" />
            <img src="https://cdn.magicpatterns.com/uploads/2ZH9LKbT3LtVRi8TwvUxsg/heylloyd-image-1771382677325.png" alt="A1C Shockproof Manual on Tablet" className="relative z-10 w-full max-w-sm mx-auto h-auto object-contain drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-46" />
          </motion.div>

          {/* CTA Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-8 text-left order-1 lg:order-2" data-id="element-47">
            <h2 className="text-3xl md:text-5xl font-bold text-white uppercase leading-tight" data-id="element-48">
              No More{' '}
              <span className="text-gray-500 line-through decoration-accent decoration-4" data-id="element-49">
                Chicken-And-Broccoli
              </span>{' '}
              Boredom.
            </h2>

            <div className="space-y-4 text-xl text-gray-300" data-id="element-50">
              <p data-id="element-51">
                You don't need another diet rule. You need an{' '}
                <span className="text-accent font-bold" data-id="element-52">
                  Interception Protocol
                </span>
                .
              </p>
              <p data-id="element-53">
                Get the A1C SHOCKPROOF (50+) Manual today. Stop being a victim
                of your lab results and start engineering the numbers you
                deserve.
              </p>
            </div>

            <div className="pt-4 pb-4" data-id="element-54">
              <a href="https://www.betterbysteps.com/cart/44209467392093:1" target="_blank" rel="noopener noreferrer" className="w-full px-12 py-5 bg-accent hover:bg-[#d55515] text-white text-xl font-bold rounded shadow-lg glow-orange transition-all duration-300 transform hover:scale-105 flex items-center justify-center uppercase tracking-wider no-underline" data-id="element-55">
                Get The Protocol $6.36
              </a>

              <div className="mt-4 flex items-center justify-center lg:justify-start gap-2 text-sm text-gray-500 font-medium" data-id="element-56">
                <ShieldCheck className="w-4 h-4 text-accent" data-id="element-57" />
                <span data-id="element-58">
                  60-Day Money-Back Guarantee • Instant Digital Download
                </span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* What Happens Next */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-gray-900/50 border border-gray-800 rounded-xl p-8 max-w-3xl mx-auto" data-id="element-59">
          <h3 className="text-xl font-bold text-white uppercase tracking-wide mb-8 text-center" data-id="element-60">
            What Happens Next:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-61">
            <div className="flex flex-col items-center text-center space-y-3" data-id="element-62">
              <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-white font-bold border border-gray-700" data-id="element-63">
                1
              </div>
              <p className="text-sm text-gray-300" data-id="element-64">
                Click the button above and complete your secure checkout
              </p>
            </div>
            <div className="flex flex-col items-center text-center space-y-3" data-id="element-65">
              <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-accent font-bold border border-accent/30" data-id="element-66">
                <Download className="w-5 h-5" data-id="element-67" />
              </div>
              <p className="text-sm text-gray-300" data-id="element-68">
                Check your email for instant download access
              </p>
            </div>
            <div className="flex flex-col items-center text-center space-y-3" data-id="element-69">
              <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-green-500 font-bold border border-green-900/50" data-id="element-70">
                <CheckCircle2 className="w-5 h-5" data-id="element-71" />
              </div>
              <p className="text-sm text-gray-300" data-id="element-72">
                Start the 30-Day Calibration protocol tonight
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}